import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Row, Col, Card, Tab, Nav, Modal, Spinner, Button } from "react-bootstrap";
import { Profile, DocumentText, Video, Star, ArrangeHorizontal, Information, Calendar} from "iconsax-react";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Select from "react-select";
import FormIDSMaestro from "../../../../components/Maestri/profilo/formIDSMaestro";
import VideoMaestro from "../../../../components/Maestri/profilo/videoMaestro";
import SportMaestro from "../../../../components/Maestri/profilo/sportMaestro";
import FeedbackMaestro from "../../../../components/Maestri/profilo/feedbackMaestro";
import DisponibilitaMaestro from "../../../../components/Maestri/profilo/disponibilitaMaestro";
import MyApiClient from "../../../../../api-client/MyApiClient";
import DynamicLogo from "../../../DynamicLogoLoader";
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import { useMemberships } from "../../../../../hooks/useMemberships";
import { sports } from "../../../../components/Util/enum";
import { sidSelectStyles } from "../../../../components/Util/sidSelectStyles";
import { conMotivo } from "../../../../components/Util/erroreServer";
import { usePageTitle, useStatoInSolaLettura, statoProfilo } from "../../../../layouts/PageHeaderExtra";

const MaestroProfile = () => {

	const { id } = useParams();

	const [loadingShowed, setLoadingShowed] = useState(false);

	const [profile, setProfile] = useState(null);
	// Stato del profilo in sola lettura subito dopo il titolo (manca l'API per cambiarlo)
	const statoProf = statoProfilo(profile?.idsGuru?.profileStatus);
	useStatoInSolaLettura(statoProf.label, statoProf.tono);
	const [labelNome, setLabelNome] = useState('');

	// Titolo della pagina = nome del maestro; finché non è caricato resta quello generico
	usePageTitle(labelNome);

	/*
	 * Rimozione del maestro dalla struttura: prima stava nel menu a fine riga della lista
	 * (anagrafiche/maestri/index.js). Se insegna piu' sport si rimuove per uno sport alla volta.
	 */
	const navigate = useNavigate();
	const { getConfirmedMembers, invalidateCache } = useMemberships({ autoFetch: true });
	const sportDelMaestro = useMemo(
		() => [...new Set(getConfirmedMembers('COACH').filter((m) => m.userId === id).map((m) => m.sport).filter(Boolean))],
		[getConfirmedMembers, id],
	);
	const eMaestroDellaStruttura = getConfirmedMembers('COACH').some((m) => m.userId === id);
	const [confirmRemoveShowed, setConfirmRemoveShowed] = useState(false);
	const [sportDaRimuovere, setSportDaRimuovere] = useState('');
	const [errore, setErrore] = useState('');

	const continueDelete = (sportType = null) => {

		setConfirmRemoveShowed(false);

		const deleteData = async () => {
			try {
				const tokenDetailsString = sessionStorage.getItem('userDetails');
				if (tokenDetailsString) {
					const tokenDetails = JSON.parse(tokenDetailsString);
					const token = tokenDetails.idToken;
					const apiClient = new MyApiClient();

					setLoadingShowed(true);
					let deleteResult = null;
					if (sportType) {
						deleteResult = await apiClient.deleteMembershipBySport(token, id, 'COACH', sportType);
					} else {
						deleteResult = await apiClient.deleteMembership(token, id, 'COACH');
					}
					setLoadingShowed(false);

					if(!deleteResult) {
						setErrore(conMotivo("Si è verificato un errore durante la cancellazione"));
					} else {
						// Svuota la cache, altrimenti la lista mostrerebbe ancora il maestro
						invalidateCache();
						navigate('/struttura/maestri/list');
					}
				}
			} catch (error) {
				setLoadingShowed(false);
				console.error("Error fetching data:", error);
			}
		};

		deleteData();
	};

	const chiediRimozione = () => {
		setSportDaRimuovere(sportDelMaestro.length === 1 ? sportDelMaestro[0] : '');
		setConfirmRemoveShowed(true);
	};
	
    const tabData = [
		{
			name: "IDS",
			icon: <Profile size='18' variant='Bulk' />,
			content: <FormIDSMaestro isDisabled={true} profile={profile} />,
		},
		{
			name: "Video di presentazione",
			icon: <Video size='18'  />,
			content: <VideoMaestro profile={profile}/>,
		},
		{
			name: "Sport",
			icon: <DocumentText size='18' />,
			content:<SportMaestro profile={profile}/>,
		},
		{
			name: "Disponibilità",
			icon: <Calendar size='18' variant='Bulk' />,
			content:<DisponibilitaMaestro profile={profile}/>,
		},
		{
			name: "Feedback",
			icon: <Star size='18' />,
			content:<FeedbackMaestro profile={profile}/>,
		}/*,
		{
			name: "Note private",
			icon: <Note size='18' variant="Bulk" />,
			content:<NoteMaestro/>,
		},*/
	];

	const location = useLocation();
    const query = new URLSearchParams(location.search);
    const [defaultTab, setDefaultTab] = useState(query.get('tab') || tabData[0].name.toLowerCase());

    useEffect(() => {
        const tab = new URLSearchParams(location.search).get('tab');
		if (tab && tab !== defaultTab) {
            setDefaultTab(tab);
        }
    }, [location.search, defaultTab]);

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const [profileData] = await Promise.all([
                        apiClient.getProfiles(token, id)
                    ]);
					setLoadingShowed(false);

					let labelNomeTemp = '';
					if(profileData.idsGuru) {
						labelNomeTemp = profileData.idsGuru.givenName+' '+profileData.idsGuru.familyName;
					}
					setLabelNome(labelNomeTemp);

					setProfile(profileData);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [id]);

	const isNotCompleted = profile && profile.idsGuru.profileStatus !== 'COMPLETED' && profile.idsGuru.profileStatus !== 'ACTIVE';

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={confirmRemoveShowed} centered>
				<Modal.Header>
					<Modal.Title>Rimuovere il maestro?</Modal.Title>
					<Button onClick={() => setConfirmRemoveShowed(false)} variant="" className="btn-close"></Button>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col className="col-lg-12">
							{sportDelMaestro.length > 1
								? <>Scegli lo sport per cui rimuovere <strong>{labelNome}</strong> dalla tua struttura.</>
								: <>Vuoi rimuovere <strong>{labelNome}</strong> dalla tua struttura?</>}
						</Col>
						{sportDelMaestro.length > 1 && (
							<Col className="col-lg-12 pt-3">
								<label className="form-label">Sport</label>
								<Select
									value={sports.find((option) => option.value === sportDaRimuovere) || null}
									options={sports.filter((s) => sportDelMaestro.includes(s.value))}
									onChange={(option) => setSportDaRimuovere(option ? option.value : '')}
									styles={sidSelectStyles}
								/>
							</Col>
						)}
					</Row>
				</Modal.Body>
				<Modal.Footer className="justify-content-center sid-footer-conferma">
					<Button className="btn btn-light btn-add" onClick={() => setConfirmRemoveShowed(false)}>Annulla</Button>
					<Button
						className="btn btn-danger btn-add"
						disabled={sportDelMaestro.length > 1 && !sportDaRimuovere}
						onClick={() => continueDelete(sportDaRimuovere || null)}
					>
						Rimuovi
					</Button>
				</Modal.Footer>
			</Modal>

			<Modal className="fade" show={!!errore} onHide={() => setErrore('')} centered>
				<Modal.Header closeButton><Modal.Title>Errore durante l'operazione</Modal.Title></Modal.Header>
				<Modal.Body>{errore}</Modal.Body>
				<Modal.Footer className="justify-content-center sid-footer-conferma">
					<Button className="btn btn-primary btn-add" onClick={() => setErrore('')}>Chiudi</Button>
				</Modal.Footer>
			</Modal>

			<div className="custom-tab-1">
				<Tab.Container defaultActiveKey={tabData[0].name.toLowerCase()}>
					<Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
						{tabData.map((data, i) => (
							<Nav.Item as="li" key={i} className="tabMenu">
								<Nav.Link eventKey={data.name.toLowerCase()}>
									{data.name}
								</Nav.Link>
							</Nav.Item>
						))}
					</Nav>
					<Row className="align-items-start mt-4">
						<div className="col-xl-9">
							<Tab.Content>
								{tabData.map((data, i) => (
									<Tab.Pane eventKey={data.name.toLowerCase()} key={i}>
										{data.content}
									</Tab.Pane>
								))}
							</Tab.Content>
							<div className={`d-flex ${eMaestroDellaStruttura ? 'justify-content-between' : 'justify-content-end'} mt-4`}>
								{eMaestroDellaStruttura && (
									<button type="button" className="btn btn-danger light" onClick={chiediRimozione}>Rimuovi</button>
								)}
								<button type="button" className="btn btn-dark light" onClick={() => navigate('/struttura/maestri/list')}>Indietro</button>
							</div>
						</div>
						<div className="col-xl-3">
							<Card>
								<Card.Body className="text-center">
									{profile && profile.idsGuru.picture && <DynamicLogo logoUrl={profile ? profile.idsGuru.picture : ''} altText="Logo Staff Tecnico" />}
									{(!profile || !profile.idsGuru.picture) && <img alt="Immagine Staff Tecnico" src={DEFAULT_USER} style={{width: '100%'}} altText="Logo Staff Tecnico" />}
									<h4 className="text-start mb-0 mt-4 text-warning">{labelNome}</h4>
									<p className="text-start mt-0 pt-0">Staff Tecnico</p>
									{profile && <Link to={'/struttura/clienti/player_profile/'+profile.idsGuru.userId} className="btn btn-sm btn-booking"><ArrangeHorizontal variant="Bulk" /><span className='ms-2'>Visualizza profilo player</span></Link>}
									
									{isNotCompleted && (
									<Link to={'#'} className="btn btn-sm btn-profile mt-2">
										<Information variant="Bulk" /><span className='ms-2'>Profilo non completato</span>
									</Link>)}
								</Card.Body>
							</Card>
						</div>
					</Row>
				</Tab.Container>
			</div>
		</>
	)
}
export default MaestroProfile;